"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const react_i18next_1 = require("react-i18next");
const svgs_1 = require("@@/assets/svgs");
const components_1 = require("@/common/components");
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const Collapse_1 = __importDefault(require("@mui/material/Collapse"));
const styled_1 = __importDefault(require("@emotion/styled"));
const _1 = require(".");
function default_1() {
    const deliveryType = (0, react_redux_1.useSelector)((state) => state.deliveryType);
    const isCustomDelivery = deliveryType === '6';
    const [expand, setExpand] = (0, react_1.useState)(true);
    const isLeaderBlocked = (0, react_redux_1.useSelector)((state) => state.roomData.is_leader_block_user);
    const paytype = (0, react_redux_1.useSelector)((state) => state.roomData.paytype);
    const paytypeIsUnder14 = paytype === 'under_14';
    const whoAmI = (0, react_redux_1.useSelector)((state) => state.whoAmI);
    const userIsCertified = whoAmI.is_certified;
    const userIsUnder14 = whoAmI.is_under_14;
    const isDemandSurvey = (0, react_redux_1.useSelector)((state) => state.isDemandSurvey);
    const { t } = (0, react_i18next_1.useTranslation)();
    if (isLeaderBlocked) {
        return ((0, jsx_runtime_1.jsx)(OrderBlockCart, Object.assign({ id: "cart_order_div" }, { children: (0, jsx_runtime_1.jsx)(components_1.MapleStoryButton, Object.assign({ isClosed: true }, { children: t('작가님과 대화가 필요해요!') })) })));
    }
    if (!isDemandSurvey && paytypeIsUnder14 && userIsCertified && userIsUnder14) {
        return ((0, jsx_runtime_1.jsx)(OrderBlockCart, Object.assign({ id: "cart_order_div" }, { children: (0, jsx_runtime_1.jsx)(components_1.MapleStoryButton, Object.assign({ isClosed: true }, { children: t('작가님 요청으로 만 14세 이상만 구매 가능!') })) })));
    }
    return ((0, jsx_runtime_1.jsxs)(CartOrderDiv, Object.assign({ id: "cart_order_div" }, { children: [(0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ disableRipple: true, sx: {
                    justifySelf: 'center',
                    width: '28px',
                    height: '20px',
                    p: 0,
                    '&:hover': {
                        bgcolor: 'transparent',
                    },
                    svg: {
                        transform: expand ? 'rotateX(180deg)' : 'rotateX(0deg)',
                        transition: 'transform .5s ease-in',
                    },
                }, onClick: () => setExpand(!expand) }, { children: (0, jsx_runtime_1.jsx)(svgs_1.CartTopSvg, {}) })), (0, jsx_runtime_1.jsxs)(Collapse_1.default, Object.assign({ in: expand, timeout: 150 }, { children: [(0, jsx_runtime_1.jsx)(_1.CartProductSelect, {}), (0, jsx_runtime_1.jsx)(_1.CartProducts, {}), isCustomDelivery && (0, jsx_runtime_1.jsx)(_1.CartCustomDeliverySelect, {}), expand && (0, jsx_runtime_1.jsx)(_1.CartTotal, { expand: expand })] })), (0, jsx_runtime_1.jsx)(_1.OrderSubmit, { expand: expand })] })));
}
exports.default = default_1;
const OrderBlockCart = styled_1.default.div `
  position: sticky;
  bottom: 0;
  display: flex;
  width: 100%;
  padding: 16px 16px 40px;
  border-radius: 20px 20px 0 0;
  background-color: white;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.2);
  z-index: 2;
`;
const CartOrderDiv = styled_1.default.div `
  position: sticky;
  bottom: 0;
  display: grid;
  width: 100%;
  padding: 0 20px 16px;
  border-radius: 20px 20px 0 0;
  background-color: white;
  box-shadow: 0px 0px 5px 3px rgba(0, 0, 0, 0.15);
  z-index: 2;
`;
